import { styled } from "@mui/material/styles";
import { Stack, type StackProps } from "@mui/system";

interface BackgroundContainerProps extends StackProps {
	/**
	 * Custom height for the container. Accepts any valid CSS height value.
	 * Defaults to '100vh'.
	 */
	height?: string;

	/**
	 * Custom padding for extra-small screens.
	 * Accepts a number (theme spacing unit) or a string (specific CSS padding value).
	 * Defaults to theme.spacing(2).
	 */
	paddingXs?: number | string;

	/**
	 * Custom padding for small and larger screens.
	 * Accepts a number (theme spacing unit) or a string (specific CSS padding value).
	 * Defaults to theme.spacing(4).
	 */
	paddingSm?: number | string;
	children?: React.ReactNode;
}

const BackgroundContainer: React.FC<BackgroundContainerProps> = ({
	children,
	direction = "row",
	justifyContent = "center",
	alignItems = "center",
	...rest
}) => {
	const StyledStack = styled(Stack)(({ theme }) => ({
		height: "100vh",
		minHeight: "100%",
		padding: theme.spacing(2),
		[theme.breakpoints.up("sm")]: {
			padding: theme.spacing(4),
		},
		position: "relative",
		// "&::before": {
		// 	content: '""',
		// 	display: "block",
		// 	position: "absolute",
		// 	inset: 0,
		// 	zIndex: -1,
		// 	...(theme.direction === "rtl"
		// 		? {
		// 				left: 0,
		// 				transform: "scaleX(-1) ",
		// 				backgroundPosition: "left",
		// 			}
		// 		: {
		// 				right: 0,
		// 				backgroundPosition: "right",
		// 			}),
		// 	backgroundImage: `url('/src/assets/images/back.svg')`,
		// 	backgroundPosition: "right",
		// 	backgroundRepeat: "no-repeat",
		// },
		// backgroundColor: theme.palette.background.paper,
	}));

	return (
		<StyledStack
			direction={direction}
			justifyContent={justifyContent}
			alignItems={alignItems}
			{...rest}
		>
			{children}
		</StyledStack>
	);
};

export default BackgroundContainer;
